import React from "react";
import Body from "./body";

export default function Details() {
  return <Body />;
}
